import { has, keys, isArray, flattenDeep } from 'lodash-es'

// normal

export function defineGetter({
  obj,
  key,
  get
}) {
  Object.defineProperty(obj, key, { get, enumerable: true, configurable: true })
  return obj
}

export function defineGetters(obj, ...rawArgs) {
  const args = makePairs(rawArgs)

  for (const { key, get } of  args) {
    defineGetter({ obj, key, get })
  }

  return obj
}

// hidden

export function defineHiddenGetter({
  obj,
  key,
  get
}) {
  Object.defineProperty(obj, key, { get, enumerable: false, configurable: true })
  return obj
}

export function defineHiddenGetters(obj, ...rawArgs) {
  const args = makePairs(rawArgs)

  for (const { key, get } of args) {
    defineHiddenGetters({ obj, key, get })
  }

  return obj
}

// helpers

function makePairs(args) {
  return flattenDeep(args.map((arg) => {
    if (isArray(arg)) {
      return makePairs(arg)
    } else if (has(arg, 'key') && has(arg, 'get')) {
      return arg
    } else {
      return keys(arg).map((key) => {
        const get = arg[key]
        return { key, get }
      })
    }
  }))
}
